export default __webpack_public_path__ + "static/media/ic_done.a79b01cf.svg";